'use client';
import styles from './statusModal.module.scss';
import {
  Medium14,
  PrimaryButton,
  SecondaryButton,
  SemiBold12,
  SemiBold20,
} from '@/components/design-system';
import { StatusModalType } from './statusModal.type';
import Image from 'next/image';
import QueryWidget from './queryWidget/queryWidget';
import CopyText from '../copyText/copyText';
import AnimatedDiv from '../animated/animated';
import { classNames } from '@/core/utils/class.utils';

const StatusModal = ({
  loading,
  imageUrl,
  title = 'We Encountered an Error',
  description = 'We could not perform this action, please try after sometime.',
  copyText,
  copyPrefix,
  queryWidget,
  customQueryWidget,
  showPrimaryButton = true,
  primaryButtonText = 'Okay',
  onPrimaryButtonClick,
  secondaryButtonText,
  onSecondaryButtonClick,
  titleColor,
  primaryButtonClevertapEventName,
  secondaryButtonClevertapEventName,
  primaryButtonClevertapEventPayload,
  secondaryButtonClevertapEventPayload,
  showQueryWidget = true,
  isButtonsRow = false,
  isButtonRowMobile = false,
  customContent,
}: StatusModalType) => {
  return (
    <AnimatedDiv.BottomToTopWithOpacity
      className={styles['status-modal-main-con']}
    >
      <AnimatedDiv.BottomToTopWithOpacity
        className={styles['status-modal-content-img-con']}
      >
        {typeof imageUrl === 'string' ? (
          <div className={styles['img-con']}>
            <Image
              src={imageUrl || '/images/error/500.png'}
              alt="error-img"
              width={120}
              height={120}
              className={styles['img']}
            />
          </div>
        ) : (
          imageUrl
        )}
        <div className={styles['status-modal-content-con']}>
          <div className={styles['title-subtitle-con']}>
            <div className={styles['title-con']}>
              {typeof title === 'string' ? (
                <SemiBold20 color={titleColor}>{title}</SemiBold20>
              ) : (
                title
              )}
            </div>
            <div className={styles['sub-title-con']}>
              {typeof description === 'string' ? (
                <Medium14 color="var(--text-body)">{description}</Medium14>
              ) : (
                description
              )}
            </div>
          </div>
          {copyText &&
            (typeof copyText === 'string' ? (
              <div className={styles['claim-no-main-con']}>
                <div className={styles['claim-no-con']}>
                  <CopyText handleCopy={(copy) => copy(copyText)}>
                    <SemiBold12 color="var(--primary-midnight)">
                      {copyPrefix} {copyText}
                    </SemiBold12>
                  </CopyText>
                </div>
              </div>
            ) : (
              copyText
            ))}
          {customQueryWidget
            ? customQueryWidget
            : queryWidget &&
              showQueryWidget && (
                <QueryWidget
                  contactText={queryWidget.contactText}
                  contactMail={queryWidget.contactMail}
                />
              )}
          {customContent}
        </div>
      </AnimatedDiv.BottomToTopWithOpacity>
      <AnimatedDiv.ZoomInWithOpacity
        className={classNames(styles['buttons-con'], {
          [styles['btns-row']]: isButtonsRow,
          [styles['btns-row-mobile']]: isButtonRowMobile,
        })}
      >
        {showPrimaryButton && (
          <PrimaryButton
            parentWidth
            onClick={onPrimaryButtonClick}
            loading={loading}
            clevertapEventName={primaryButtonClevertapEventName}
            clevertapEventPayload={primaryButtonClevertapEventPayload}
          >
            {primaryButtonText}
          </PrimaryButton>
        )}
        {onSecondaryButtonClick != undefined && secondaryButtonText && (
          <SecondaryButton
            onClick={onSecondaryButtonClick}
            parentWidth
            clevertapEventName={secondaryButtonClevertapEventName}
            clevertapEventPayload={secondaryButtonClevertapEventPayload}
          >
            {secondaryButtonText}
          </SecondaryButton>
        )}
      </AnimatedDiv.ZoomInWithOpacity>
    </AnimatedDiv.BottomToTopWithOpacity>
  );
};

export default StatusModal;
